import React, { useContext, useEffect, useState } from 'react'
import { errorSchema, utils } from 'helper'
import { CommonInput, CommonModal, CustomSelect } from 'components'
import StorageService from 'utils/StorageServices/StorageServices'
import { getBranchDropdownListData, getConsignorDropdownListData } from '_services/dropdownServices/dropdownService'
import { fetchConsignorDetailsData } from '_services/accountsServices/consignorServices'
import { getEwayBillLrData } from '_services/accountsServices/ewayBillServices'
import toast from 'react-hot-toast'
import { UserContext } from 'context'

const formObj = {
    party: {},
}

const AddEwayPartyModal = (props) => {

    let { isOpen, manualNextModal, isCurrentModelClose = () => { }, addButtonAction, showPrefield, secondSubmit, isAddLrLater, filledLocation = {}, isOpenModelClose, disableBranchConsignor = false } = props;
    const { permissionModal, ewayBillInitialData, setEwayBillInitialData } = useContext(UserContext)
    const [formValue, setFormValue] = useState(formObj);
    const [formError, setFormError] = useState({});
    const [loading, setLoading] = useState(false);
    const [consignorList, setConsignorList] = useState([]);
    const [dropdownBranchList, setDropdownBranchList] = useState([]);
    const [permissionError, setPermissionError] = useState(false);

    const gst_number = localStorage.getItem("gst_number");

    const getDropdownDataConsignorList = async () => {
        try {
            let object = {
                company_id: StorageService.getCompanyId(),
                firm_id: ewayBillInitialData?.branch_id?.firm_id?._id ? ewayBillInitialData?.branch_id?.firm_id?._id : StorageService.getFirmId(),
                search: '',
            }
            const res = await getConsignorDropdownListData(object);
            setLoading(false);
            if (res?.responseCode == 200) {
                setConsignorList(res?.data?.consignor_list)
            }
        } catch (error) {
            // throw error;
        }
    }

    useEffect(() => {
        setLoading(true);
        getDropdownDataConsignorList();
    }, [])

    const onhandleSelect = async (item, name) => {
        const stateObj = { ...formValue, [name]: item };
        setFormValue(stateObj);

        if (!utils.isObjectKeyEmpty(formError)) {
            const validationResult = await utils.checkFormError(stateObj, errorSchema.createEwayBillModalSchema2);
            if (validationResult === true) {
                setFormError({});
            } else {
                setFormError(validationResult);
            }
        }
    };

    const singleConsignorData = async () => {
        setLoading(true);
        try {
            let object = {
                consignor_id: formValue?.party?.value,
                company_id: StorageService.getCompanyId(),
            }
            const res = await fetchConsignorDetailsData(object);
            if (res?.responseCode == 200) {
                manualNextModal(res?.data?.consignor);
                isCurrentModelClose(false);
                setLoading(false);
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    // const fetchEwayBillData = async () => {
    //     try {
    //         let object = {
    //             consignor_id: formValue?.party?.value ? formValue?.party?.value : '',
    //             branch_id: formValue?.branch_id?.value ? formValue?.branch_id?.value : '',
    //             company_id: StorageService.getCompanyId(),
    //             ewbNo: formValue?.eway_bill_no ? formValue?.eway_bill_no : null,
    //         }
    //         let object2 = {
    //             consignor_id: formValue?.party?.value,
    //             company_id: StorageService.getCompanyId(),
    //         }
    //         const ewayBillResponse = await getEwayBillLrData(object);
    //         const consignorResponse = await fetchConsignorDetailsData(object2);

    //         if (ewayBillResponse?.responseCode == 200 && consignorResponse?.responseCode == 200) {
    //             nextModal({ ...consignorResponse?.data?.consignor, eway_bill: ewayBillResponse?.data, isEditLr: true });
    //             isOpenModelClose(false);
    //             // StorageService.setGstNumber('');
    //             setFormValue({});
    //             setLoading(false);
    //         } else {
    //             if (ewayBillResponse?.responseMessage) {
    //                 toast.error(`${ewayBillResponse?.responseMessage}`);
    //             }
    //             setLoading(false);
    //         }
    //     } catch (error) {
    //         setLoading(false);
    //         // toast.error(`Eway bill data not found`);
    //     }
    // }

    const handleSubmit = async (event, is_eway) => {
        event.preventDefault();
        const validationResult = await utils?.checkFormError(formValue, errorSchema.createEwayBillModalSchema2);
        if (utils?.isObjectKeyEmpty(validationResult)) {
            if (is_eway === 'add_manually') {
                setEwayBillInitialData({ ...ewayBillInitialData, ...formValue, is_eway_fetch: false });
                singleConsignorData();
                // isOpenModelClose(false);
            }
            // else {
            //     if (!formValue?.branch_id?.is_eway_integration) {
            //         setPermissionError(true)
            //     } else {
            //         setPermissionError(false)
            //         setLoading(true);
            //         fetchEwayBillData();
            //         setEwayBillInitialData({ ...formValue, is_eway_fetch: true });
            //         setFormError("");
            //     }
            // }
        } else {
            setFormError(validationResult);
            setLoading(false);
        }
    }

    useEffect(() => {
        if (consignorList?.length > 0 && showPrefield) {
            setFormValue((s) => ({
                ...s,
                party: consignorList?.map((el) => {
                    return {
                        label: el?.name,
                        value: el?._id,
                    }
                })[0],
            }))
        }
    }, [consignorList, showPrefield])

    useEffect(() => {
        if (consignorList?.length > 0 && consignorList?.length === 1) {
            setFormValue((s) => ({
                ...s,
                party: consignorList?.map((el) => {
                    return {
                        label: el?.name,
                        value: el?._id,
                    }
                })[0],
            }))
        }
    }, [consignorList])

    const buttonActionHandler = () => {
        addButtonAction(true);
        isCurrentModelClose(false);
    }

    const addEwayBillManually = () => {

    }

    const propsLrModalInhance = {
        ...props,
        isLoadding: loading,
        disabled: loading || permissionError,
        onSubmit: (e) => handleSubmit(e, 'add_manually'), // handleSubmit(e), // 
        modalZIndex: permissionModal ? -1 : '',
        closeModal: (e) => isCurrentModelClose(true),
        // cancelButtonTitle: 'Close'
    }

    const handleOnChange = async (name, value) => {
        const stateObj = { ...formValue, [name]: value };
        setFormValue(stateObj);

        if (!utils.isObjectKeyEmpty(formError)) {
            const validationResult = await utils.checkFormError(stateObj, errorSchema.createEwayBillModalSchema2);
            if (validationResult === true) {
                setFormError("");
            } else {
                setFormError(validationResult);
            }
        }
    };

    useEffect(() => {
        setFormValue((s) => ({
            ...s,
            party: isOpen?.consignor_id?._id ? {
                label: isOpen?.consignor_id?.name,
                value: isOpen?.consignor_id?._id,
            } : {},
        }))
    }, [isOpen])

    return (
        <>
            <CommonModal {...propsLrModalInhance}>
                <div className='addItem_body mt-2'>
                    <div className='colFlx'>
                        <div className='singleDiv'>
                            <CustomSelect
                                options={consignorList?.map((el) => {
                                    return {
                                        label: el?.name,
                                        value: el?._id,
                                        consignor_code: el?.consignor_code,
                                        template_no: el?.template_no,
                                    }
                                })}
                                name="party"
                                label="Select Party"
                                placeholder="Select Party"
                                isAddButton={true}
                                addButtonAction={(e) => buttonActionHandler(e)}
                                value={formValue?.party?.value ? formValue?.party : {}}
                                error={formError["party.label"]}
                                // error={!!(typeof formError === "object") ? formError?.party : ""}
                                onSelect={(data) => onhandleSelect(data, 'party')}
                                disabled={disableBranchConsignor ? true : false}
                            />
                        </div>
                    </div>
                </div>
            </CommonModal>
        </>
    )
}

export default React.memo(AddEwayPartyModal);